var _desc, _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "X",
    width: 24,
    height: 24,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.043 4.57117L18.043 4.54285C18.4385 4.14697 19.0615 4.14697 19.457 4.54285C19.8535 4.93884 19.8535 5.56116 19.457 5.95715L19.4287 5.95715L18.043 4.57117ZM5.95703 19.4288L5.95703 19.4572C5.56152 19.853 4.93848 19.853 4.54297 19.4572C4.14648 19.0612 4.14648 18.4388 4.54297 18.0428L4.57129 18.0428L5.95703 19.4288ZM19.4287 18.0428L19.457 18.0428C19.8535 18.4388 19.8535 19.0612 19.457 19.4572C19.0615 19.853 18.4385 19.853 18.043 19.4572L18.043 19.4288L19.4287 18.0428ZM4.57129 5.95715L4.54297 5.95715C4.14648 5.56116 4.14648 4.93884 4.54297 4.54285C4.93848 4.14697 5.56152 4.14697 5.95703 4.54285L5.95703 4.57117L4.57129 5.95715Z",
    fill: "#FB0B24",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 5.25L12 12L5.25 18.75M18.75 18.75L12 12M12 12L5.25 5.25",
    stroke: "#FB0B24",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.b984d049d861e8e2371fb35dbf49a834.svg";
export { ForwardRef as ReactComponent };